import React, { useEffect, useState } from 'react';
import styles from './ResearchOpportunities.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { debounce, isEmpty } from 'lodash';
import { useFetchResearchOpportunities } from '../../../Hooks/Research';
import ResearchOpportunityTable from '../../Molecules/ResearchOpportunity/ResearchOpportunityTable';
import TopHeader from '../../Molecules/SpeechAndTestimonials/TopHeader';

const ResearchesOpportunities = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const [usersPageSize, setUsersPageSize] = useState(10);
  const [usersPage, setUsersPage] = useState(1);

  const { data, refetch, isLoading } = useFetchResearchOpportunities(
    usersPageSize,
    usersPage
  );

  const tableHeader = [
    {
      name: 'عنوان البحث',
      originalName: 'department.titleAR',
      colSpan: 2,
    },
    {
      name: 'قطاع البحث',
      originalName: 'department.text_AR',
      colSpan: 1,
    },
    {
      name: 'البريد الإلكتروني',
      originalName: 'email',
      colSpan: 1,
    },
    {
      name: 'تاريخ النشر',
      originalName: 'publicationDate',
      colSpan: 1,
    },
    {
      name: '',
      originalName: '',
      colSpan: 1,
      flag: true,
    },
  ];

  useEffect(() => {
    refetch();
  }, [usersPage, usersPageSize]);

  useEffect(() => {
    if (!isEmpty(search)) {
      handleSearch();
    }
  }, [search]);

  const handleSearch = debounce(() => {}, 300);

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate('/home/create-research-opportunity');
  };

  return (
    <div className={styles.cont}>
      <TopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={handleNavigate}
        buttonTitle="بحث جديد"
      />
      <ResearchOpportunityTable
        data={data?.data}
        refetchUsers={refetch}
        page={usersPage}
        setPage={setUsersPage}
        pageSize={usersPageSize}
        setPageSize={setUsersPageSize}
        tableHeader={tableHeader}
        isUsersLoading={isLoading}
      />
    </div>
  );
};

export default ResearchesOpportunities;
